import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

type urlFunc = (input: any) => string;
type onResponseErro = (input: any) => void;
type onResponseFile = (file: downloadedFile) => void;

export interface downloadedFile {
  blob: Blob,
  filename: string,
  type: string
}

export function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  let bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}


@Injectable({
  providedIn: 'root'
})

export abstract class BaseRelService {
  abstract apiController: string;

  abstract consultarUrl: urlFunc;
  abstract excelUrl: urlFunc;

  constructor(public http: HttpClient) { }

  public consultar<R>(input: any): Observable<R> {
    return this.get(`${this.consultarUrl(input)}`, this.apiController);
  };

  public consultarPorId<R>(id: number, pk_name: string = "id"): Observable<R> {
    let filter = {};
    filter[pk_name] = id;
    return this.consultar(filter);
  };

  public excel(input: any,
    success: onResponseFile,
    error: onResponseErro = (err) => console.error("erro", err)) {

    return this.get(`${this.excelUrl(input)}`, this.apiController)
      .subscribe((response: any) => {
        let content = response.retorno.fileContents;
        let filename = response.retorno.fileDownloadName;
        let type = response.retorno.contentType;

        const arrBuffer = base64ToArrayBuffer(content);
        const blob = new Blob([arrBuffer], {
          type,
        });

        success({ blob, filename, type });

      }, error);
  };

  protected getRoot<R>(url: string): Observable<R> {
    return this.http.get<R>(`${url}`, httpOptions);
  };

  protected get<R>(url: string, controller: string = null): Observable<R> {
    var root = `${controller ?? this.apiController}/`;
    return this.http.get<R>(`${root}${url}`, httpOptions);
  };

  protected put<R>(url: string, input: any, controller: string = null): Observable<HttpResponse<R>> {
    var root = `${controller ?? this.apiController}/`;
    return this.http.put<R>(`${root}${url}`, input, { observe: 'response' });
  };

  protected post<R>(url: string, input: any, controller: string = null): Observable<HttpResponse<R>> {
    var root = `${controller ?? this.apiController}/`;
    return this.http.post<R>(`${root}${url}`, input, { observe: 'response' });
  };

  protected delete<R>(url: string, controller: string = null): Observable<R> {
    var root = `${controller ?? this.apiController}/`;
    return this.http.delete<R>(`${root}${url}`, httpOptions);
  };
}
